import React from 'react';
import { Link } from 'react-router-dom';

function VisaAssistance() {
  return (
    <article className="seo-page-container" style={{ 
      padding: 'clamp(15px, 4vw, 30px)', 
      background: '#fff', 
      margin: 'clamp(10px, 3vw, 20px)', 
      borderRadius: '4px', 
      textAlign: 'left', 
      fontFamily: 'Arial, sans-serif',
      boxSizing: 'border-box'
    }}>
      
      {/* MOBILE BREAKPOINT STYLES OVERRIDE */}
      <style>{`
        @media (max-width: 550px) {
          .visa-footer-btn { width: 100% !important; text-align: center; box-sizing: border-box; }
        }
      `}</style>

      {/* HEADER HERO SECTION */}
      <header>
        <h1 style={{ 
          color: '#0b3c5d', 
          marginBottom: '15px', 
          fontSize: 'clamp(1.5rem, 6vw, 2.4rem)', 
          fontWeight: '700', 
          lineHeight: '1.3' 
        }}>
          Medical Visa Assistance for Delhi NCR: Navigating Indian Immigration Protocols Safely
        </h1>
        <p style={{ color: '#444', lineHeight: '1.8', fontSize: 'clamp(0.95rem, 3.5vw, 1.1rem)', marginBottom: '24px' }}>
          Securing the correct legal entry clearance is the primary operational benchmark when planning cross-border healthcare. For international patients seeking advanced private procedures—such as complex cardiothoracic bypass surgeries, robotic joint reconstructions, or targeted oncology regimens—entering the country under the correct sovereign visa category ensures smooth processing at border control points.
        </p>
        <p style={{ color: '#444', lineHeight: '1.8', fontSize: 'clamp(0.95rem, 3.5vw, 1.1rem)', marginBottom: '25px' }}>
          By tracking regulatory requirements on independent research indices like <strong>Medical Trip World</strong>, traveling families can discover how to secure an official <strong>e-Medical Visa</strong>, map application timelines, and compile required documentation fields without administrative complications.
        </p>
      </header>

      {/* CALL TO ACTION BUTTON */}
      <div style={{ marginBottom: '35px' }}>
        <Link to="/submit-query" style={{ 
          background: '#28a745', 
          color: '#fff', 
          padding: '14px 24px', 
          textDecoration: 'none', 
          borderRadius: '4px', 
          fontWeight: 'bold', 
          display: 'inline-block', 
          boxShadow: '0 2px 4px rgba(40,167,69,0.2)',
          fontSize: '0.95rem',
          textAlign: 'center',
          boxSizing: 'border-box',
          maxWidth: '100%'
        }}>
          Request Free Pre-Travel Immigration & Cost Guides →
        </Link>
      </div>

      {/* SECTION 1: E-MEDICAL VISA FRAMEWORK */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #e2e8f0', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Understanding the Indian e-Medical Visa Framework
        </h2>
        <p style={{ color: '#555', lineHeight: '1.7', marginBottom: '15px', fontSize: '0.95rem' }}>
          Sovereign immigration laws offer an electronic entry model specifically tailored for international healthcare consumers. The triple-entry <strong>e-Medical Visa</strong> is highly practical, permitting multiple entry entries within a 60-day validity window to cover primary procedures, intermediate outpatient follow-ups, and subsequent diagnostic checks.
        </p>
        <p style={{ color: '#555', lineHeight: '1.7', margin: 0, fontSize: '0.95rem' }}>
          Furthermore, national protocols allow up to two close family members to accompany the primary patient under a corresponding <strong>e-Medical Attendant Visa</strong>. Unlike state-run public networks, premium private multi-specialty hospital groups in New Delhi, Gurgaon, and Noida manage dedicated international divisions that issue the mandatory legal documentation required to clear these entry authorizations quickly.
        </p>
      </section>

      {/* SECTION 2: DOCUMENTATION CHECKLIST MATRIX */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #e2e8f0', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Mandatory Medical Visa Application Documentation
        </h2>
        <p style={{ color: '#555', lineHeight: '1.6', fontSize: '0.95rem' }}>
          When organizing your visa application files to prevent processing delays, standard international immigration guidance emphasizes compiling the following core data segments:
        </p>

        <div style={{ background: '#f4f8fb', padding: 'clamp(15px, 4vw, 20px)', margin: '25px 0', borderRadius: '6px', borderLeft: '4px solid #005ba1', border: '1px solid #e2e8f0', borderLeftColor: '#005ba1', boxSizing: 'border-box' }}>
          <h3 style={{ marginTop: '0', color: '#005ba1', fontSize: '1.15rem', marginBottom: '12px' }}>📋 Required Visa Application Document Profiles:</h3>
          <ul style={{ marginTop: '10px', listStyleType: 'square', paddingLeft: '20px', lineHeight: '1.8', color: '#333', fontSize: '0.95rem' }}>
            <li style={{ marginBottom: '8px' }}><strong>Official Visa Invitation Letter (VIL):</strong> A formal, stamped letter generated by a licensed private hospital stating your identity, passport specifics, diagnosed condition, and estimated surgical duration. This letter must be uploaded directly to the immigration portal.</li>
            <li style={{ marginBottom: '8px' }}><strong>Valid Passport Framework:</strong> Ensure your international passport possesses at least 6 months of active structural validity remaining from your arrival date and houses at least two blank entry stamp pages.</li>
            <li style={{ marginBottom: '8px' }}><strong>Local Healthcare Referral Letters:</strong> Digital copies of diagnostic history summaries or medical recommendations signed by an operating specialist in your home country.</li>
            <li style={{ marginBottom: '0' }}><strong>Inbound/Outbound Travel Proof:</strong> Confirmed round-trip flight bookings or clear itinerary schedules to satisfy border entry metrics regarding intended departure windows.</li>
          </ul>
        </div>
      </section>

      {/* SECTION 3: SAFETY & LOCAL FRRO REGISTRATIONS - RESPONSIVE MOBILE GRID */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #e2e8f0', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Post-Arrival Regulations: Foreign Regional Registration (FRRO)
        </h2>
        <p style={{ color: '#555', lineHeight: '1.6', fontSize: '0.95rem' }}>
          Because Medical Trip World operates exclusively as an open informational venue and independent directory reference, we remind traveling families to follow proper post-landing administrative safety benchmarks:
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '20px', marginTop: '15px' }}>
          <div style={{ padding: '20px', background: '#fafafa', borderRadius: '6px', border: '1px solid #e2e8f0', boxSizing: 'border-box' }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#0b3c5d', fontSize: '1.05rem', fontWeight: '700' }}>Mandatory 14-Day FRRO Tracking</h4>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.5' }}>
              All international health tourists must file registration forms with the Foreign Regional Registration Office (FRRO) within 14 days of landing. Private international desks process this documentation digitally for you.
            </p>
          </div>
          <div style={{ padding: '20px', background: '#fafafa', borderRadius: '6px', border: '1px solid #e2e8f0', boxSizing: 'border-box' }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#0b3c5d', fontSize: '1.05rem', fontWeight: '700' }}>Independent Verification Rights</h4>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.5' }}>
              Patients maintain the absolute right to cross-reference their hospital invitation specifics directly with their selected private facility to verify entry validity before submission.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 4: IN-DEPTH FAQ */}
      <section style={{ marginBottom: '35px', background: '#fff', border: '1px solid #e2e8f0', padding: 'clamp(15px, 4vw, 25px)', borderRadius: '6px', boxShadow: '0 1px 3px rgba(0,0,0,0.02)' }}>
        <h3 style={{ color: '#0b3c5d', marginTop: '0', marginBottom: '20px', fontSize: '1.25rem', fontWeight: '700' }}>
          Frequently Asked Questions (FAQs) – Visa Assistance & Immigration
        </h3>
        
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 6px 0', fontSize: '0.95rem' }}>Can an international patient travel for surgical care using a tourist visa?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            No. National immigration laws explicitly mandate that foreign citizens entering the country for purposeful medical care must hold a valid Medical Visa. Undergoing surgery or checking into a private multi-specialty hospital under a standard tourist visa is illegal and directly violates clinical registration protocols.
          </p>
        </div>
        
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 6px 0', fontSize: '0.95rem' }}>What happens if a patient's treatment timeline requires an extended stay?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            If clinical parameters (such as bone marrow transplant monitoring or post-op cardiac setbacks) demand an extended recovery window, private hospital care teams file official medical extension requests with the FRRO on your behalf to adjust your visa duration safely.
          </p>
        </div>
        
        <div style={{ marginBottom: '0' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 6px 0', fontSize: '0.95rem' }}>Does Medical Trip World process visa applications or issue invitation letters?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            No. Medical Trip World functions exclusively as an independent informational reference manual and open directory framework. We do not process immigration applications, interface with sovereign embassies, or issue official medical invitation letters. All invitation materials, financial cost commitments, and clinical care obligations are executed directly and solely between the patient and their independently selected private medical provider.
          </p>
        </div>
      </section>

      {/* RE-ENGAGEMENT FOOTER */}
      <footer style={{ borderTop: '1px solid #eee', paddingTop: '20px', textAlign: 'center' }}>
        <p style={{ fontSize: '1.05rem', fontWeight: 'bold', color: '#333', margin: '0 0 15px 0' }}>Empower Your Global Healthcare Research Journey Safely</p>
        <div style={{ display: 'flex', gap: '12px', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center' }}>
          <Link to="/submit-query" className="visa-footer-btn" style={{ background: '#28a745', color: '#fff', padding: '12px 20px', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '0.9rem', display: 'inline-block', boxShadow: '0 2px 4px rgba(40,167,69,0.15)' }}>
            Submit General Information Request
          </Link>
          <Link to="/compare-costs" className="visa-footer-btn" style={{ background: '#fff', color: '#0b3c5d', border: '2px solid #0b3c5d', padding: '10px 20px', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '0.9rem', display: 'inline-block' }}>
            View Estimated Cost Charts
          </Link>
        </div>
      </footer>

    </article>
  );
}

export default VisaAssistance;